module.exports = __webpack_public_path__ + "static/Aneta-055c3d58d01fca09aa9b8ba19da5c422.mp4";